import React, { Component } from "react";
import { s360ConfigService } from "../../Services/S360Config";
import dayjs from "dayjs";
import { isNullOrUndefined } from "../../HWLibrary/HWUtils";

class MessageA14 extends Component {

    constructor(props) {
        super(props);
        this.messageRef = React.createRef();
        this.state = {value:true};
    }

    render() {
        return (
            <div className="s360-message-cotainer-received">
                <div className="s360-message-box-custom-a14-received" style={this.messageBoxStyle()}>
                    <input
                    
                     onFocus={e => e.currentTarget.select()}
                     type="text" ref={this.messageRef} 
                     onChange={(e)=>
                        this.onChangeHandler(e)
                     }
                     className="s360-message-box-custom-a14-textbox-input" onClick={this.onClickInput} onKeyPress={this.onInputKeyPress} onBlur={this.onInputOut} style={this.formInputBoxStyle()} />
                </div>
                { this.props.isLastEntry && this.props.sentTimestamp&& <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(this.props.sentTimestamp).format("DD MMM h:mm a")}</div>}
                <div className="s360-message-cotainer-received">
                    <button disabled={this.state.value || this.props.disabled} className="s360-message-box-custom-a15-received" onClick={this.onSubmit} onMouseEnter={this.onMouseEnterButton} onMouseLeave={this.onMouseLeaveButton} style={this.messageBoxSubmitStyle()}>
                    {(this.props.entry.data)?JSON.parse(this.props.entry.data).buttonText:'Submit'}
                    </button>
                </div>
            </div>
        );
    }
    onChangeHandler = (e)=>{
        if(e.target.value!==""){
            this.props.scrollToLatest();
            this.setState({value:false})
        }else{
            this.setState({value:true})
        }
    }
    onMouseEnterButton = (e) => {
        if (!e.target) { return }
        if (e.target.disabled === true) { return }
        const designDetails = s360ConfigService.config.designDetails;
        e.target.style.color           = isNullOrUndefined(designDetails.buttonHighlightTextColor)       ? "#f8f5f5" : designDetails.buttonHighlightTextColor;
        e.target.style.backgroundColor = isNullOrUndefined(designDetails.buttonHighlightBackgroundColor) ? "#2935dd" : designDetails.buttonHighlightBackgroundColor;
        e.target.style.borderColor = isNullOrUndefined(
              designDetails.buttonHighlightBorderColor
            )
              ? isNullOrUndefined(designDetails.buttonBorderColor)
                ? "#0092ed"
                : designDetails.buttonBorderColor
              : designDetails.buttonHighlightBorderColor;
    }

    onMouseLeaveButton = (e) => {
        if (!e.target) { return }
        // if (e.target.disabled === true) { return }
        const designDetails = s360ConfigService.config.designDetails;
        e.target.style.color           = isNullOrUndefined(designDetails.buttonTextColor)       ? "#0092ed" : designDetails.buttonTextColor;
        e.target.style.backgroundColor = isNullOrUndefined(designDetails.buttonBackgroundColor) ? "#fff" : designDetails.buttonBackgroundColor;
        e.target.style.borderColor = isNullOrUndefined(designDetails.buttonBorderColor)
            ? "#0092ed"
            : designDetails.buttonBorderColor;
    }

    messageBoxStyle = () => {
        return { background: s360ConfigService.config.designDetails.senderMessageColor, fontFamily: s360ConfigService.config.designDetails.SenderMessageFont, fontSize: s360ConfigService.config.designDetails.SenderMessageFontSize, color: s360ConfigService.config.designDetails.senderMessageFontColor }
    }

    formInputBoxStyle = () => {
        return {
             borderColor: s360ConfigService.config.designDetails.headerColor,
              color: s360ConfigService.config.designDetails.buttonTextColor, 
              backgroundColor: s360ConfigService.config.designDetails.pageBackgroundColor,
            fontWeight: 500 }
    }

    onInputKeyPress = (e) => {
         
        
       
        if(e.key === 'Enter') {
            this.messageRef && this.messageRef.current && this.messageRef.current.blur();
            const ref =  this.messageRef.current;
     this.onMouseLeaveButton(e);
       if(ref.value.trim().length >0)
       {
            this.props.actions.sendMessage(ref.value.trim());
       }
        }
    }

    onClickInput = (item) => {
         
      this.setState({value: false});
    }
    
    onInputOut = () => {
        let value = this.messageRef && this.messageRef.current && this.messageRef.current.value && this.messageRef.current.value.trim();
        // if (value) {
        //     this.props.actions.sendMessage(value);
        // }
        //this.setState({value: value});
    }


    onSubmit = (e) => {
      //  this.setState({value: false});
     // let value = this.messageRef && this.messageRef.current && this.messageRef.current.value && this.messageRef.current.value.trim();
     const ref =  this.messageRef.current;
     this.onMouseLeaveButton(e);
       if(ref.value.trim().length >0)
       {
            this.props.actions.sendMessage(ref.value.trim());
       }
     }

    messageBoxSubmitStyle = () => {
        const designDetials = s360ConfigService.config.designDetails;
        let styleData = { 
            // background: s360ConfigService.config.designDetails.recieverMessageColor, 
            fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont, 
            fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize, 
            // color: s360ConfigService.config.designDetails.recieverMessageFontColor,
            marginLeft: '15px',
            borderWidth:"1px", 
            borderStyle: "solid",
            borderColor: isNullOrUndefined(designDetials.buttonBorderColor) ? "#0092ed" : designDetials.buttonBorderColor,

            borderRadius:    isNullOrUndefined(designDetials.buttonBorderRadius)    ? 20 : designDetials.buttonBorderRadius,
            color:           isNullOrUndefined(designDetials.buttonTextColor)       ? "#0092ed" : designDetials.buttonTextColor,
            backgroundColor: isNullOrUndefined(designDetials.buttonBackgroundColor) ? "#fff" : designDetials.buttonBackgroundColor,
        }
        return styleData;
        // return { 
        //     background: s360ConfigService.config.designDetails.recieverMessageColor, 
        //     fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont, 
        //     fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize, 
        //     color: s360ConfigService.config.designDetails.recieverMessageFontColor,
        //     marginLeft: '15px' 
        // }
    }

}

export default MessageA14;